import { render, staticRenderFns } from "./ProductionFacilityType.vue?vue&type=template&id=2da55148"
import script from "./ProductionFacilityType.vue?vue&type=script&lang=js"
export * from "./ProductionFacilityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports